module.exports = __webpack_public_path__ + "img/fsg_coaches.930b9412.svg";